import type { DonationFrequency } from '@/lib/stripe-billing';

export const DONATE_WIDGET_HASH = '#donationwidget';
export const DONATE_MONTHLY_HASH = '#monthly';
export const DONATE_ONE_TIME_HASH = '#one-time';

const LEGACY_ONE_TIME_SLUGS = new Set([
  '/donate#donationwidget',
  '/donate#donation-widget',
]);

const ONE_TIME_NAV_IDS = new Set(['f-gi-onetime']);

/**
 * Maps CMS/footer nav labels (and known stale slugs) to the correct /donate hash.
 * Firestore nav may still store /donate#donationwidget for One-Time Gift.
 */
export function resolveDonateNavHref(
  label: string,
  href: string,
  navItemId?: string
): string {
  const trimmed = href.trim();
  if (!trimmed.startsWith('/donate')) {
    return href;
  }

  if (navItemId && ONE_TIME_NAV_IDS.has(navItemId)) {
    return `/donate${DONATE_ONE_TIME_HASH}`;
  }

  if (LEGACY_ONE_TIME_SLUGS.has(trimmed.toLowerCase())) {
    const labelLower = label.trim().toLowerCase();
    if (
      labelLower.includes('one-time') ||
      labelLower.includes('one time') ||
      labelLower.includes('one-time gift')
    ) {
      return `/donate${DONATE_ONE_TIME_HASH}`;
    }
  }

  const labelLower = label.trim().toLowerCase();
  if (labelLower.includes('one-time') || labelLower.includes('one time')) {
    return `/donate${DONATE_ONE_TIME_HASH}`;
  }
  if (labelLower.includes('donate monthly') || labelLower === 'monthly gift') {
    return `/donate${DONATE_MONTHLY_HASH}`;
  }

  return href;
}

export function donationFrequencyFromHash(hash: string): DonationFrequency | null {
  const normalized = hash.toLowerCase();
  if (
    normalized === DONATE_ONE_TIME_HASH ||
    normalized === '#onetime' ||
    normalized === '#one_time'
  ) {
    return 'one_time';
  }
  if (normalized === DONATE_MONTHLY_HASH) {
    return 'monthly';
  }
  return null;
}

export function donationFrequencyFromSearch(search: string): DonationFrequency | null {
  const value = new URLSearchParams(search).get('frequency')?.toLowerCase();
  if (value === 'one_time' || value === 'one-time' || value === 'onetime') {
    return 'one_time';
  }
  if (value === 'monthly') {
    return 'monthly';
  }
  return null;
}

export function shouldScrollDonationWidget(hash: string): boolean {
  const normalized = hash.toLowerCase();
  return (
    normalized === DONATE_WIDGET_HASH ||
    normalized === DONATE_MONTHLY_HASH ||
    normalized === DONATE_ONE_TIME_HASH ||
    normalized === '#onetime' ||
    normalized === '#one_time'
  );
}

export function defaultAmountsForDonationFrequency(frequency: DonationFrequency): {
  selectedAmount: number;
  customAmountInput: string;
} {
  if (frequency === 'one_time') {
    return { selectedAmount: 25, customAmountInput: '25' };
  }
  return { selectedAmount: 10, customAmountInput: '10' };
}
